import tw from "#src/utils/tw.ts";

interface Props {
  value?: string;
  defaultValue?: string;
  placeholder: string;
  readOnly?: boolean;
  className?: string;
  onChange?: (value) => void;
  onBlur?: (value) => void;
  maxLength?: number;
  name?: string;
  rows?: number;
  disabled?: boolean;
  allowClear?: boolean;
  onClear?: () => void;
  isPreview?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
}

export default function InputTextarea(props: Props) {
  function onChange(e) {
    const value = e.target.value;

    if (props.onChange) {
      props.onChange(value);
    }
  }

  function onBlur(e) {
    const value = e.target.value;

    if (props.onBlur) {
      props.onBlur(value);
    }
  }

  function clearValue() {
    if (props.onChange) {
      props.onChange("");
    }

    if (props.onClear) {
      props.onClear();
    }
  }

  return (
    <div className="relative">
      <div
        className={tw(
          "whitespace-pre-line",
          "p-4",
          "border",
          "invisible",
          props.className
        )}
        style={{
          minHeight: 100,
        }}
      >
        {props.value + "\n"}
      </div>
      <textarea
        placeholder={props.placeholder}
        value={props.value}
        onChange={onChange}
        readOnly={props.readOnly}
        maxLength={props.maxLength}
        name={props.name}
        defaultValue={props.defaultValue}
        onBlur={onBlur}
        rows={props.rows}
        disabled={props.disabled}
        className={tw(
          "hover:border-organization border-borderGray bg-bgGray placeholder-empty absolute top-0 right-0 bottom-0 left-0 w-full resize-none rounded-sm border px-4 py-2 transition",
          props.isPreview && "hover:border-borderGray focus-within:outline-none"
        )}
        onKeyDown={props.onKeyDown}
      />
      {props.allowClear && props.value && (
        <button
          className="absolute top-3 right-3 cursor-pointer"
          onClick={clearValue}
        >
          <i aria-hidden className="far fa-circle-xmark text-empty" />
        </button>
      )}
    </div>
  );
}
